/* RS MUSC — interactions (KOMUNIK) */
(function () {
  var RS = window.RS || {};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function fmt(cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }

  /* Apparition au défilement */
  var io = null;
  if (!reduce && !designMode && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  }
  function initReveal(root) {
    root.querySelectorAll('[data-reveal]:not(.is-in)').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }

  /* Galerie produit */
  function initGallery(root) {
    root.querySelectorAll('[data-gallery]').forEach(function (g) {
      if (g.dataset.ready) return; g.dataset.ready = '1';
      var main = g.querySelector('[data-gallery-main]');
      g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          var img = main.querySelector('img');
          if (!img) return;
          var fresh = img.cloneNode();
          fresh.src = t.getAttribute('data-src');
          fresh.srcset = t.getAttribute('data-srcset') || '';
          fresh.alt = t.getAttribute('data-alt') || '';
          main.replaceChild(fresh, img);
          g.querySelectorAll('[data-gallery-thumb]').forEach(function (o) { o.setAttribute('aria-current', 'false'); });
          t.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  function initAll(root) { initReveal(root); initGallery(root); }
  initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); refreshCart(); });

  /* Quantités */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    var min = parseInt(input.min || '1', 10), max = parseInt(input.max || '99', 10);
    var v = (parseInt(input.value, 10) || 0) + (b.getAttribute('data-qty') === 'plus' ? 1 : -1);
    input.value = Math.max(min, Math.min(max, v));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Panier : compteur et barre de livraison */
  function updateShipping(total) {
    document.querySelectorAll('[data-ship]').forEach(function (el) {
      var threshold = parseInt(el.getAttribute('data-ship'), 10) || 6000;
      var fill = el.querySelector('.ship__fill'), msg = el.querySelector('.ship__msg');
      if (fill) fill.style.width = Math.min(100, Math.round(total / threshold * 100)) + '%';
      if (!msg) return;
      if (total === 0) msg.textContent = (RS.shipInitial || '').replace('[montant]', fmt(threshold));
      else if (total < threshold) msg.textContent = (RS.shipRemaining || '').replace('[montant]', fmt(threshold - total));
      else msg.textContent = RS.shipDone || '';
    });
  }
  function updateCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); });
    document.querySelectorAll('[data-cart-label]').forEach(function (el) {
      var base = (el.getAttribute('aria-label') || '').split(',')[0];
      el.setAttribute('aria-label', base + ', ' + n);
    });
  }
  function refreshCart() {
    if (!window.fetch) return Promise.resolve();
    return fetch((RS.cartUrl || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCount(cart.item_count); updateShipping(cart.total_price); return cart; })
      .catch(function () {});
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });

  /* Ajout au panier sans rechargement */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('js-ajax-cart') || !window.fetch) return;
    if (e.submitter && e.submitter.name !== 'add') return;
    e.preventDefault();
    var btn = form.querySelector('button[name="add"]');
    var msg = form.querySelector('[data-form-msg]');
    var label = btn ? btn.textContent : '';
    if (btn) btn.disabled = true;
    if (msg) { msg.textContent = ''; msg.hidden = true; }
    fetch((RS.cartAddUrl || '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Erreur');
        if (btn) btn.textContent = RS.added || label;
        return refreshCart();
      })
      .catch(function (err) { if (msg) { msg.textContent = err.message; msg.hidden = false; } })
      .then(function () {
        if (!btn) return;
        btn.disabled = false;
        setTimeout(function () { btn.textContent = label; }, 1800);
      });
  });

  /* Changement de déclinaison (si le produit en a plusieurs) */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-variant-select]')) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', e.target.value);
    window.location.href = url.toString();
  });

  /* Panier : mise à jour automatique des quantités */
  var cartForm = document.getElementById('CartForm');
  if (cartForm) {
    var timer;
    cartForm.addEventListener('change', function (e) {
      if (!e.target.matches('input[name="updates[]"]')) return;
      clearTimeout(timer);
      timer = setTimeout(function () { cartForm.submit(); }, 450);
    });
  }

  /* Menu mobile : fermeture au clic extérieur, à l'Échap et après un lien */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.menu-drawer[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    if (e.target.closest('.menu-drawer__panel a')) { var d = e.target.closest('details'); if (d) d.removeAttribute('open'); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.menu-drawer[open]').forEach(function (d) { d.removeAttribute('open'); d.querySelector('summary').focus(); });
  });
})();
